import React from "react";
import PriceCard from "./pricecards";
import './price.css';
import { useNavigate } from 'react-router-dom';

function Price({ onSelectPlan }) {
    const navigate = useNavigate();
    
    const handleSelectPlan = (planName, path) => {
        if (planName === 'PLUS') {
            // For PLUS plan, navigate to dashboard with parameter to show planner
            navigate('/dashboard?showPlanner=true');
        } else if (path) {
            // For BASIC plan, navigate to the deals page
            navigate(path);
        }
    };
    
    return(
        <div className='price_container_cards'>
            <div className="price_text_cards">
                <h6>Pricing</h6>
                {/*<p>We offer a free usage with all needed features, and a paid subscriptions with even better features enabling you as a private consumer or a business to better manage and plan you economy.</p>*/}
            </div>
        
            <div className="cards__container">
                <div className="cards__wrapper">
                    <ul className="cards__items">
                        <PriceCard 
                        //src='Images/image-1.webp'
                        //label='Basic'
                        header='BASIC'
                        text='Manage your economy'
                        price='0'
                        undertext='Includes'
                        path='/deals'
                        features={[
                            "All offers collected in one place",
                            "Latest offers and campaigns",
                            "Comparison between offers & stores",
                            "Geographic optimization between stores",
                            "Favorize stores"
                        ]}
                        onClick={() => handleSelectPlan('BASIC', '/deals')}
                        />
                        <PriceCard
                        //src='Images/image-2.webp'
                        //label='Premium'
                        header='PLUS'
                        text='While elimating waste'
                        price='69'
                        undertext='Includes'
                        features={[
                            "All from starter pack +",
                            "AI-tool for optimizing spending and routes",
                            "Platform for easy overview of budget, list and time",
                            "Valuable data-driven insights",
                        ]}
                        onClick={() => handleSelectPlan('PLUS', null)}
                        />
                    </ul>
                </div>
            </div>
            
        </div>
    );
}

export default Price;